import { render, staticRenderFns } from "./LlLink.vue?vue&type=template&id=2aa73161&scoped=true"
import script from "./LlLink.vue?vue&type=script&lang=js"
export * from "./LlLink.vue?vue&type=script&lang=js"
import style0 from "./LlLink.vue?vue&type=style&index=0&id=2aa73161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa73161",
  null
  
)

export default component.exports